import { render } from "./AppTabularText.vue?vue&type=template&id=39b04080"
import script from "./AppTabularText.vue?vue&type=script&lang=js"
export * from "./AppTabularText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__